import { render, staticRenderFns } from "./completar.vue?vue&type=template&id=fd8285c0&scoped=true&"
import script from "./completar.vue?vue&type=script&lang=js&"
export * from "./completar.vue?vue&type=script&lang=js&"
import style0 from "./completar.vue?vue&type=style&index=0&id=fd8285c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd8285c0",
  null
  
)

export default component.exports